<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <group-access>
        </group-access> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import groupAccess from './todo-group-access'
export default {
    components: {
        groupAccess
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-users/base-group-access.vue